var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state === 'VERIFYING')?_c('portal',{attrs:{"to":"modal"}},[(_vm.verificationType === 'yoti')?_c('age-verification',{on:{"close":_vm.onYotiClose}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }